(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("skeleton", [], factory);
	else if(typeof exports === 'object')
		exports["skeleton"] = factory();
	else
		root["skeleton"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 